// 创建文件en/index.js
const Thai = {
    rejected: "ถูกปฏิเสธ",
    my: "ของฉัน",
    today: "วันนี้",
    this_week: "สัปดาห์นี้",
    this_month: "เดือนนี้",
    last_month: "เดือนที่แล้ว",
    this_year: "ปีนี้",
    number_of_people: "จำนวนคน",
    amount: "จำนวนเงิน",
    enter_username_id_to_search: "กรอกชื่อผู้ใช้ ID เพื่อค้นหา",
    team_list: "รายการทีม",
    registration_time: "เวลาลงทะเบียน",
    selling_face_value: "มูลค่าหน้าขาย",
    click_for_details: "คลิกเพื่อดูรายละเอียด",
    "agent_login": "เข้าสู่ระบบตัวแทน",
    'SignOut': 'ออกจากระบบ',
    'Contact us': "ติดต่อเรา",
    'Download our app': "ดาวน์โหลดแอปของเรา",
    'Download it from': "ดาวน์โหลด URL",
    'About Us': "เกี่ยวกับเรา",
    'Gobuy USA was founded in 2012': "Gobuy USA ก่อตั้งขึ้นในปี 2012",
    'Customer service': "การบริการลูกค้า",
    'frequently asked question': "คำถามที่พบบ่อย",
    'Return and exchange policy': "นโยบายการคืนและเปลี่ยนสินค้า",
    'Shipping and distribution': "การจัดจำหน่ายและการส่งมอบ",
    'Contact us by email': "ติดต่อเราผ่านทางอีเมล",
    'Privacy Policy and Terms of Use': "นโยบายความเป็นส่วนตัวและข้อกำหนดการใช้งาน",
    'Privacy Policy': "นโยบายความเป็นส่วนตัว",
    'Terms of use': "เงื่อนไขการใช้งาน",
    'Upload credentials': "อัปโหลดข้อมูลรับรอง",
    'The withdrawal is being processed': "อยู่ระหว่างการถอนเงิน",
    'Cause of failure': "สาเหตุของความล้มเหลว",
    'Your shopping cart is still empty': "ตะกร้าสินค้าของคุณยังว่างเปล่า",
    'Log in to view the items in your cart': "เข้าสู่ระบบเพื่อดูสินค้าในตะกร้าสินค้า",
    'Browse around': "เรียกดู",
    'Account correlation': "บัญชีที่เกี่ยวข้อง",
    'Order management': "การจัดการคำสั่งซื้อ",
    'Payment method': "วิธีการชำระเงิน",
    'Collection address': "ที่อยู่การชำระเงิน",
    Category: "การจำแนกประเภท",
    "MyCommission": "ค่าคอมมิชชั่นของฉัน",
    "Gross income": "รายได้ทั้งหมด",
    "Direct commission": "ค่าคอมมิชชั่นโดยตรง",
    "Indirect commission": "ค่าคอมมิชชั่นทางอ้อม",
    "Transfer to wallet": "โอนเข้ากระเป๋าสตางค์",
    "Tip: The transfer amount must be greater than 10USDT": "เคล็ดลับ: จำนวนเงินโอนจะต้องมากกว่า 10USDT",
    "transfer": "โอนย้าย",
    "commission": "คณะกรรมการ",
    "Please enter": "กรุณาเข้า",
    'Old Password': "รหัสผ่านเก่า",
    'Change password': "เปลี่ยนรหัสผ่าน",
    'Amazon GIFT CARD': "บัตรของขวัญอเมซอน",
    'High Priced Recycling': "การรีไซเคิลราคาสูง",
    'Data': "วันที่",
    'congratulations': "ยินดีด้วย",
    'Obtain': "รับ",
    'ThankYouForParticipating': "ขอบคุณสำหรับการเข้าร่วม",

    // navbar"",
    Home: "หน้าแรก",
    Search: "ค้นหา",
    ShoppingCart: "ตะกร้าสินค้า",
    Mine: "ของฉัน",

    // 首页
    // 搜索
    EnterSearchContent: "ป้อนเนื้อหาการค้นหา",
    'Recent searches': "การค้นหาล่าสุด",
    'popular searches': "การค้นหายอดนิยม",
    'Please search': "กรุณากรอกคำสำคัญที่คุณต้องการค้นหา",
    'orderSearch': "กรอกชื่อคำสั่งซื้อหรือสินค้าเพื่อค้นหา",

    // 语言
    'Language selection': "การเลือกภาษา",

    // menu
    Brand: "ยี่ห้อ",
    Collect: "เก็บรวบรวม",
    Manage: "จัดการ",
    Order: "คำสั่ง",
    Wallet: "กระเป๋าสตางค์",
    BlindBox: "กล่องตาบอด",
    MenuGiftCard: "บัตรของขวัญ",
    // HotSale
    HotSale: "ข่าวล่าสุด กำลังลดราคา...",
    // tabs"",
    TodaysOffer: "แพลตฟอร์มที่แนะนำ",
    'Phone': "โทรศัพท์มือถือ",
    'Smart Watch': "นาฬิกาอัจฉริยะ",
    'Smart bracelet': "สร้อยข้อมืออัจฉริยะ",

    // gobuy
    'home.gobuy.title': "ความประหลาดใจกำลังรอคุณอยู่",
    'home.gobuy.periods': "กล่องตาบอดทรงกลม",
    'home.gobuy.freeze': "มีส่วนร่วมในการนับถอยหลัง",
    'home.gobuy.drawing': "เริ่มนับถอยหลัง",
    'home.gobuy.buy': "เข้าร่วม",
    'home.gobuy.isbuy': "เข้าร่วมแล้ว",
    USDT: "ดอลลาร์สหรัฐฯ",
    'home.gobuy.jackpot': "เงินรางวัลรวม",
    Purse: "กระเป๋าสตางค์",
    Box: "กล่องตาบอด",
    'GetAPrize': "รับรางวัล",
    Discount: "การลดราคา",
    when: "เมื่อไร",
    points: "บูรณาการ",
    seconds: "ที่สอง",
    // MessageBox
    'MessageBox.Tips': "คำใบ้",
    'MessageBox.Confirm': "ยืนยัน",
    'MessageBox.Cancel': "ยกเลิก",
    'MessageBox.buy.box': "คุณแน่ใจหรือไม่ว่าต้องการซื้อกล่องตาบอดนี้",
    // Toast
    'succ': "ความสำเร็จ",
    'err': "ความผิดพลาด",
    'box.succeeds': "การซื้อสำเร็จ",
    'box.frozen': "เข้าร่วมแล้ว",
    'box.issue': "สามารถซื้อกล่องตาบอดได้เพียงกล่องเดียวต่อฉบับ",

    // 商品列表
    filter: "กรอง",
    sales: "ปริมาณการขาย",
    selfOP: "ดำเนินการด้วยตนเอง",
    noMore: "ไม่มีอีกแล้ว",
    brand: "ยี่ห้อ",
    confirm: "ยืนยัน",
    reset: "รีเซ็ต",
    ComSor: "การเรียงลำดับที่ครอบคลุม",
    MostPop: "ที่นิยมมากที่สุด",
    HighLow: "ราคาจากสูงไปต่ำ",
    LowHigh: "ราคาจากต่ำไปสูง",
    SalVol: "ปริมาณการขาย",
    NewArr: "มาใหม่",

    // 购物车
    'cart.cart': "ตะกร้าสินค้า",
    'cart.edit': "แก้ไข",
    'cart.done': "เสร็จ",
    'home.cart.voucher': "รับคูปอง",
    'home.cart.outstock': "สินค้าหมด",
    'home.cart.offshelf': "ถอดออกจากชั้นวางแล้ว",
    'Only': "เท่านั้น",
    'left': "รายบุคคล",
    'Promotion': "การส่งเสริม",
    'cart.all': "เลือกทั้งหมด",
    'cart.total': "ทั้งหมด",
    'cart.delete': "ลบ",
    'cart.checkout': "บิล ได้โปรด",

    // 我的
    'Direct': "โดยตรง",
    'Indirect': "ทางอ้อม",
    'MyOrders': "คำสั่งซื้อของฉัน",
    'ViewAll': "ดูทั้งหมด",
    'Unpaid': "รอการชำระเงิน",
    'ToShip': "รอจัดส่ง",
    'ToReceive': "รอรับ",
    'ToReview': "รอการประเมิน",
    // 盲盒
    'MyBlindBox': "รายการกล่องตาบอด",
    'WaitingDraw': "รอหวยครับ",
    'Opened': "เปิดแล้ว (รับ/คืน)",
    // 礼品卡
    'After sale': "หลังการขาย",
    'GiftCard': "บันทึกการรีไซเคิล",
    'RecycleGiftCard': "รีไซเคิลบัตรของขวัญ",
    'Verifying': "ตรวจสอบ",
    'Rebuying': "การซื้อคืน",
    'Repurchased': "รอการชำระเงิน",
    'Paid': "ชำระเงินเรียบร้อยแล้ว",
    // 常用工具
    'CommonTools': "เครื่องมือทั่วไป",
    'MyWallet': "กระเป๋าเงินของฉัน",
    'VirtualOrders': "คำสั่งซื้อเสมือน",
    'Refunds': "คืนเงิน",
    'MyFriends': "เพื่อนของฉัน",
    'ChatList': "รายการสนทนา",
    'RealNameVerification': "การตรวจสอบชื่อจริง",
    'MyFavorites': "คอลเลกชันของฉัน",
    'Addresses': "การจัดการที่อยู่",
    'MyReviews': "รีวิวของฉัน",
    'BrowsingHistory': "เรียกดูประวัติ",
    'Promotions': "โปรโมชั่น",
    'StoreManagement': "การจัดการร้านค้า",
    'BecomeASeller': "มาเป็นผู้ขาย",

    // 订单列表
    'SearchPlaceholder': "กรอกชื่อสินค้าที่ต้องการค้นหา",
    All: "ทั้งหมด",
    OrderNo: "หมายเลขคำสั่งซื้อ",
    items: "ชิ้นส่วน",
    ShippingFee: "ค่าขนส่ง",
    'Refund in Progress': "อยู่ระหว่างดำเนินการคืนเงิน",
    'Cancel Order': "ยกเลิกคำสั่งซื้อ",
    'Refund': "คืนเงิน",
    'Track Shipping': "ตรวจสอบโลจิสติกส์",
    'Confirm Receipt': "ยืนยันการรับสินค้า",
    'Evaluate': "ประเมิน",
    'Delete': "ลบ",
    'Pay': "การชำระเงิน",
    'MessageBox.delete.order': "คุณแน่ใจหรือไม่ว่าต้องการลบคำสั่งซื้อนี้",
    'MessageBox.cancel.order': "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกคำสั่งซื้อนี้",
    'MessageBox.receive.order': "คำสั่งซื้อนี้ได้รับแล้วหรือยัง?",
    // 订单详情
    'Order Details': "รายละเอียดการสั่งซื้อ",
    'Pickup Code': "รหัสการรับสินค้า",
    'Complaint': "ร้องเรียน",
    'After-Sales': "หลังการขาย",
    'Gift': "ของขวัญ",
    'Order Date': "วันที่สั่งซื้อ",
    'Used voucher worth': "จำนวนบัตรกำนัลที่ใช้",
    'CNY': "หยวน",
    'Payment Method': "วิธีการชำระเงิน",
    'Total Product Amount': "จำนวนผลิตภัณฑ์ทั้งหมด",
    'Shipping Fee': "ค่าขนส่ง",
    'Amount Paid': "จำนวนเงินที่ชำระ",
    'Return': "คืนสินค้า",
    // 盲盒列表
    'Pending Draw': "รอการจับสลาก",
    'Pending Unboxing': "ที่จะถูกเปิด",
    'Unboxed': "เปิดอยู่แล้ว",
    'Collected': "ได้รับ",
    'Recycled': "รีไซเคิล",
    'Unknown': "ไม่ทราบ",
    'Claim': "รับ",
    'Recycle': "การซื้อคืน",
    'Unbox': "เปิดเครื่อง",
    'MessageBox.recycle.box': "คุณแน่ใจหรือไม่ว่าต้องการรีไซเคิลกล่องตาบอดนี้",
    // 盲盒详情
    'Mystery Box Details': "รายละเอียดกล่องตาบอด",
    'Unopened': "ไม่ได้เปิด",
    'box.opened': "ไม่ได้เปิด",
    'Claimed': "ได้รับ",
    'Confirm Claim': "ยืนยันการรวบรวม",
    'MessageBox.pick.box': "คุณแน่ใจหรือไม่ว่าต้องการแยกกล่องตาบอดนี้",
    // 盲盒提货
    'Please add address': "กรุณาเพิ่มที่อยู่",
    // 礼品卡列表
    'Face Value Total': "มูลค่าหน้าบัตรทั้งหมด",
    // 礼品卡详情
    'Gift Card Details': "รายละเอียดบัตรของขวัญ",
    'Card number': "หมายเลขบัตร",
    'Activation code': "รหัสเปิดใช้งาน",
    'Actual recovery price': "ราคารีไซเคิลตามจริง",
    // 礼品卡回收
    'Gift Card Recycling': "การรีไซเคิลบัตรของขวัญ",
    'Confirm Recycling': "ยืนยันการรีไซเคิล",
    'Please enter the card number': "กรุณากรอกหมายเลขบัตร",
    'Please enter the activation code': "กรุณากรอกรหัสเปิดใช้งาน",
    'MessageBox.recycle.gift': "คุณแน่ใจหรือไม่ว่าต้องการรีไซเคิลบัตรของขวัญนี้",

    // 我的钱包
    'My Wallet': "กระเป๋าเงินของฉัน",
    'Available Balance': "ยอดคงเหลือที่มีอยู่",
    'Frozen Funds': "แช่แข็งเงินทุน",
    'Recharge': "เติมเงิน",
    "can": "สามารถ",
    'Withdraw': "ถอนเงินสด",
    'Withdrawal Accounts': "ถอนบัญชี",
    // 充值
    'Recharge Details': "รายละเอียดการเติมเงิน",
    'Recharge Order No.': "หมายเลขคำสั่งซื้อเติมเงิน",
    'Recharge Amount': "จำนวนการเติมเงิน",
    'Creation Time': "เวลาสร้าง",
    'MessageBox.recharge.pop': "กรุณากรอกจำนวนเงินที่เติม",
    // 付款
    'payment': "การชำระเงิน",
    'Order submitted successfully, please select payment method': "ส่งคำสั่งซื้อเรียบร้อยแล้ว กรุณาเลือกวิธีการชำระเงิน",
    'Rechargeable card': "การ์ดแบบชาร์จไฟได้",
    'Please enter a hash': "กรุณาใส่แฮช",
    'Immediate payment': "ชำระเงินตอนนี้",
    'Wait for the file to load': "กรุณารอให้โหลดไฟล์",
    // 提现
    'Withdrawal Details': "รายละเอียดการถอนเงิน",
    'Withdrawal Amount': "ถอนจำนวนเงิน",
    'Application Time': "เวลาสมัคร",
    'New Application': "แอปพลิเคชันใหม่",
    'Payment Password': "รหัสผ่านการชำระเงิน",
    'New Payment Password': "รหัสผ่านการชำระเงินใหม่",
    'Recipient Information': "ข้อมูลผู้รับเงิน",
    'Submit': "ส่ง",
    'Add Recipient Account First': "กรุณาเพิ่มบัญชีการชำระเงินก่อน",
    'Please bind your mobile phone or email first': "กรุณาผูกโทรศัพท์มือถือหรืออีเมลของคุณก่อน",
    // 设置
    'Account Settings': "การตั้งค่าบัญชี",
    'Change Login Password': "เปลี่ยนรหัสผ่านเข้าสู่ระบบ",
    'Change Payment Password': "เปลี่ยนรหัสผ่านการชำระเงิน",
    'Log Out': "ออกจากระบบ",
    'Mobile': "โทรศัพท์มือถือ",
    'Verification Code': "รหัสยืนยัน",
    'Email': "จดหมาย",
    'New Password': "รหัสผ่านใหม่",
    'Confirm Password': "ยืนยันรหัสผ่าน",
    'Modify': "ปรับปรุงใหม่",
    'Bind': "ผูกพัน",
    ' Mobile': "โทรศัพท์มือถือ",
    ' Email': "จดหมาย",
    // 资金详情
    'Fund Details': "รายละเอียดเงินทุน",
    'Withdrawal Account': "ถอนบัญชี",
    'Account Type': "ประเภทบัญชี",
    'USDT Address (TRC20)': "ที่อยู่ USDT (TRC20)",
    'Edit': "แก้ไข",
    'Delete': "ลบ",
    'Add New': "เพิ่มบัญชีใหม่",
    'MessageBox.delete.bank': "คุณแน่ใจหรือไม่ว่าต้องการลบบัญชีถอนเงินนี้",
    // 登录
    'Login': "เข้าสู่ระบบ",
    'Sign Up': "ลงทะเบียน",
    'Normal Login': "เข้าสู่ระบบปกติ",
    'Username / Email / Phone Number': "ชื่อผู้ใช้/อีเมล",
    'Enter Phone Number': "กรุณากรอกหมายเลขโทรศัพท์มือถือ",
    'Enter Email': "กรุณากรอกอีเมล์",
    'Enter SMS Code': "กรุณากรอกรหัสยืนยันทาง SMS",
    'Enter Password': "กรุณากรอกรหัสผ่าน",
    "enter_login_password_for_verification": "กรุณาใส่รหัสผ่านการเข้าสู่ระบบเพื่อยืนยัน",
    'Forgot Password': "ลืมรหัสผ่าน",
    'Third-party Login': "การเข้าสู่ระบบของบุคคลที่สาม",
    'Please complete the form': "กรุณากรอกแบบฟอร์ม",
    'WeChat': "วีแชท",
    'Weibo': "เว่ยป๋อ",
    'QQ': "คิวคิว",
    'phone login': "เข้าสู่ระบบมือถือ",
    'Login Expired': "การเข้าสู่ระบบหมดอายุแล้ว",
    'Please enter your phone number first': "กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณก่อน",
    'Please enter your username/email/phone number': "กรุณากรอกชื่อผู้ใช้/อีเมล",
    'Please enter your password': "กรุณากรอกรหัสผ่าน",
    'Password must be at least 6 characters': "รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร",
    'Please enter an 11-digit phone number': "กรุณากรอกหมายเลขโทรศัพท์มือถือ 11 หลักของคุณ",
    'Please wait for the file to finish loading': "กรุณารอจนกว่าไฟล์จะโหลด",
    'send': "ส่ง",
    'signUpTips': "ข้อมูลส่วนบุคคลของคุณจะถูกนำมาใช้เพื่อสนับสนุนประสบการณ์ของคุณทั่วทั้งเว็บไซต์ จัดการการเข้าถึงบัญชีของคุณ และเพื่อวัตถุประสงค์อื่นที่อธิบายไว้ในนโยบายความเป็นส่วนตัวของเรา",

    // 注册
    'Sign Up': "ลงทะเบียน",
    'Referrer': "ผู้แนะนำ",
    'Invitation code': "รหัสคำเชิญ",
    'Invite friends': "ชวนเพื่อน",
    'Username': "ชื่อผู้ใช้",
    'Full Name': "ชื่อจริง",
    'Set Password': "ตั้งรหัสผ่าน",
    'Confirm Password': "ยืนยันรหัสผ่าน",
    'Phone Number': "หมายเลขโทรศัพท์",
    'Email': "อีเมล",
    'Username: 3-25 chars, letters & numbers': "ชื่อผู้ใช้: 3-25 ตัวอักษร ตัวอักษร และตัวเลข",
    '6-20 digits/letters/symbols': "6-20 หลัก/ตัวอักษร/สัญลักษณ์",
    'By clicking sign up, you agree to': "การคลิกเพื่อลงทะเบียนแสดงว่าคุณยอมรับ",
    'User Agreement': "ข้อตกลงผู้ใช้",
    'Please check the user agreement': "โปรดตรวจสอบข้อตกลงผู้ใช้",
    'Please enter a username with 3-25 characters': "กรุณากรอกชื่อผู้ใช้ที่มีความยาว 3-25 ตัวอักษร",
    'Enter SMS Verification Code': "กรุณากรอกรหัสยืนยันทาง SMS",
    'Please enter your phone number': "กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ",
    'Please enter the verification code': "กรุณากรอกรหัสยืนยัน",
    'Please enter a 6-digit verification code': "กรุณากรอกรหัสยืนยัน 6 หลัก",
    'Please enter a password with 6-20 characters': "กรุณากรอกรหัสผ่าน 6-20 ตัวอักษร",
    'Please enter the confirm password': "กรุณากรอกรหัสผ่านยืนยัน",
    'The confirm password does not match the entered password': "รหัสผ่านยืนยันไม่ตรงกับรหัสผ่านที่ป้อน",

    // 密码恢复
    'Password Recovery': "การกู้คืนรหัสผ่าน",
    'Forgot Password': "ลืมรหัสผ่าน",
    'Forget.email.tips': "หากบัญชีของคุณยังไม่เชื่อมโยงกับหมายเลขอีเมล โปรดติดต่อผู้ดูแลแพลตฟอร์มเพื่อกู้คืนรหัสผ่านของคุณ",

    // 通知
    'Notification Message': "ข้อความแจ้งเตือน",
    'Direct Message': "ข้อความส่วนตัว",
    'System Message': "ข้อความของระบบ",
    'Leave a Message': "ข้อความ",

    // 配送地址
    'Delivery Address': "ที่อยู่จัดส่ง",
    'The store is no longer valid, please edit the delivery address again': "ร้านค้านี้ใช้ไม่ได้อีกต่อไป โปรดแก้ไขที่อยู่สำหรับจัดส่งอีกครั้ง",
    'Default address': "ที่อยู่เริ่มต้น",
    'Add address': "เพิ่มที่อยู่",
    'Edit address': "แก้ไขที่อยู่",
    'MessageBox.delete.address': "คุณแน่ใจหรือไม่ว่าต้องการลบที่อยู่นี้",
    'name': "ชื่อ",
    'phone': "หมายเลขโทรศัพท์",
    'district': "เขต",
    'address': "ที่อยู่",
    'default address': "ที่อยู่เริ่มต้น",
    'save and use': "บันทึกและใช้งาน",
    'save': "บันทึก",
    'Please select a region': "โปรดเลือกภูมิภาค",
    'Please fill in the recipient name': "กรุณากรอกชื่อผู้รับ",
    'Name must be 2-15 characters': "ชื่อต้องมีอักขระ 2-15 ตัว",
    'Please fill in the mobile phone number': "กรุณากรอกหมายเลขโทรศัพท์มือถือ",
    'Please select your location': "กรุณาเลือกสถานที่ของคุณ",
    'Please fill in the detailed address': "กรุณากรอกที่อยู่โดยละเอียด",

    // 浏览历史
    'Browsing History': "เรียกดูประวัติ",
    'Clear browsing history': "ล้างประวัติการเข้าชม",

    // 推广会员
    'Promotion member': "ส่งเสริมสมาชิก",
    "“PromotionPoster”": "โปสเตอร์ส่งเสริมการขาย",
    "MemberName": "ชื่อสมาชิก",
    "MyAssets": "ทรัพย์สินของฉัน",
    "DistributedAmount": "จำนวนการจำหน่าย",
    "NumberOfDistributedProducts": "กำหนดปริมาณผลิตภัณฑ์",
    "DistributedProductAmount": "จำนวนการจำหน่าย",
    "MyTeam": "ทีมของฉัน",
    "LevelOneMembers": "สมาชิกชั้นหนึ่ง",
    "LevelTwoMembers": "สมาชิกระดับที่สอง",
    "PromotionPoster": "โปสเตอร์ส่งเสริมการขาย",
    "PromotionMembers": "ส่งเสริมสมาชิก",
    "PromotionPerformance": "ประสิทธิภาพการส่งเสริมการขาย",
    "ViewPromotionLink": "คลิกดูลิงค์โปรโมชั่น",
    "PromoteViaWeChatQRCode": "โปรโมตผ่านรหัส QR WeChat",
    "Copy": "สำเนา",
    "BrowserNotSupportedCopyManually": "เบราว์เซอร์ของคุณไม่รองรับการคัดลอกโดยตรง โปรดคัดลอกด้วยตนเอง",
    "GiftCardRecoveryTotal": "จำนวนบัตรของขวัญที่รีไซเคิลทั้งหมด",
    "TodaysGiftCardRecoveryCount": "จำนวนการรีไซเคิลบัตรของขวัญในวันนี้",
    "RegistrationDate": "วันที่ลงทะเบียน",
    "LastLogin": "เข้าสู่ระบบครั้งล่าสุด",
    "Promotion Commission": "ค่าคอมมิชชั่นส่งเสริมการขาย",

    // userinfo 个人信息
    "Personal Info": "ข้อมูลส่วนบุคคล",
    "Nickname": "ชื่อนิค",
    "Birthdate": "วันเดือนปีเกิด",
    "Save": "บันทึก",
    "CropImage": "ครอบตัดรูปภาพ",
    "UseImage": "ใช้รูปภาพ",

    // goodsDetail 商品详情
    "Off": "การลดราคา",
    "Sold": "ขายแล้ว",
    "Product": "ผลิตภัณฑ์",
    "Comment": "ความคิดเห็น",
    "Details": "รายละเอียด",
    "ReportViolation": "รายงาน",
    "Cart": "ตะกร้าสินค้า",
    "ChatMessages": "ข้อความแชท",
    "MyShop": "ร้านค้าของฉัน",
    "MerchantLogin": "เข้าสู่ระบบผู้ค้า",
    "Share": "แบ่งปัน",
    "ShareTo": "แบ่งปันไปที่",
    "WeChat": "วีแชท",
    "Copy": "สำเนา",
    "Poster": "โปสเตอร์",
    "BrowserNotSupportedCopyManually": "เบราว์เซอร์ของคุณไม่รองรับการคัดลอกโดยตรง โปรดคัดลอกด้วยตนเอง",
    "Follow": "มุ่งเน้นไปที่",
    "Unfollow": "เลิกติดตาม",
    "PleaseSelectQuantityAndCategory": "กรุณาเลือกจำนวนและประเภท",
    "SelectedWithQuantity1": "เลือกแล้ว {ข้อกำหนด} ปริมาณ {จำนวน}",
    "SelectedQuantity1": "ปริมาณที่เลือก {number}",
    "SelectedWithQuantity2": "เลือกแล้ว {ข้อกำหนด} ปริมาณ {จำนวน}",
    "Add to cart": "เพิ่มลงในรถเข็น",
    "Buy now": "ซื้อเลย",
    "Stock": "ในสต็อก",
    "Pieces": "ชิ้นส่วน",
    "Quantity": "ปริมาณ",
    "All": "ทั้งหมด",
    "Good": "ความคิดเห็นที่ดี",
    "Medium": "คะแนนเป็นกลาง",
    "Bad": "รีวิวไม่ดี",
    // 评论
    "Product review": "รีวิวสินค้า",
    "anonymous": "ไม่ระบุชื่อ",
    "noReviewInfo": "ไม่มีข้อมูลความคิดเห็นให้",
    "Shop Owners Response": "แม่ค้าตอบกลับ",
    "This product has no current reviews": "ขณะนี้ไม่มีความคิดเห็นสำหรับผลิตภัณฑ์นี้",
    "Product details": "รายละเอียดสินค้า",
    "shop": "ร้านค้า",
    "customerService": "การบริการลูกค้า",
    "shoppingCart": "ตะกร้าสินค้า",
    "addToCart": "เพิ่มลงในรถเข็น",
    "buyNow": "ซื้อเลย",
    "outOfStock": "สินค้าที่เลือกอยู่ในขณะนี้หมดสต๊อก ขออภัย!",
    "notAvailable": "สินค้าที่เลือกไม่มีจำหน่ายแล้ว ขออภัย!",
    "Store order message": "ข่าวสารการสั่งซื้อของทางร้าน",
    "Confirm the order": "ยืนยันการสั่งซื้อ",
    "productAmount": "จำนวนสินค้า",
    "discount": "การลดราคา",
    "shippingFee": "ค่าขนส่ง",
    "subtotal": "เก็บผลรวมย่อย",
    "Submit an order": "ส่งคำสั่งซื้อ",
    // 退货
    "refundAdd": "เพิ่มการคืนเงิน",
    "back": "กลับ",
    "refundDescription": "คำแนะนำการคืนเงิน:",
    "proofOfRefund": "บัตรกำนัลการคืนเงิน",
    "use": "ใช้",
}
export default Thai
